export default {
    topics: [
        {
            title: ' BuildScoringFunction ',
            href: 'sm-predictiveModel-BuildScoringFunction.html',
            attributes: { 'data-id': 'sm-predictiveModel-BuildScoringFunction' },
            menu: { hasChildren: false },
            tocID: 'sm-predictiveModel-BuildScoringFunction-d66e3543',
            topics: [],
        },
        {
            title: ' GetScoringXtkExpr ',
            href: 'sm-predictiveModel-GetScoringXtkExpr.html',
            attributes: { 'data-id': 'sm-predictiveModel-GetScoringXtkExpr' },
            menu: { hasChildren: false },
            tocID: 'sm-predictiveModel-GetScoringXtkExpr-d66e3551',
            topics: [],
        },
        {
            title: ' Train ',
            href: 'sm-predictiveModel-Train.html',
            attributes: { 'data-id': 'sm-predictiveModel-Train' },
            menu: { hasChildren: false },
            tocID: 'sm-predictiveModel-Train-d66e3559',
            topics: [],
        },
    ],
};

